<template>
  <div class="Equipment-Report-Main">
    <div class="content-container">
      <div class="left-container" resizable>
        <div class="filter-container" style="flex-grow: 1">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Report Filters</div>
          <Dropdown
            placeholder="Report Type"
            :selectedObject.sync="selectedReportName"
            :items="reportNameData"
            itemKey="Report"
            :isRequired="true"
            :errorMessage.sync="errorReportName"
            @selected="reportSelected"
            style="margin-bottom: 8px"
          />

          <div class="d-flex flex-column" style="margin-bottom: 8px" v-if="!disableDateFields && selectedReportName">
            <Dropdown
              :items="activeDateFields"
              :isDisabled="activeDateFields.length <= 1"
              :selectedObject.sync="selectedDateField"
              itemKey="Date Field"
              placeholder="Date Filter"
              v-if="activeDateFields.length > 0"
            />
            <div class="d-flex align-items-center">
              <CheckBox title="" :isChecked.sync="showFromDate" @checkBoxClicked="fromDateCheckBoxClicked" />
              <DateTimePicker
                placeholder="Start Date"
                style="height: auto; top: 0"
                :value.sync="selectedFromDate"
                :showTime="false"
                :errorMessage.sync="errorFromDate"
                :isDisabled="!showFromDate"
              />
            </div>
            <div class="d-flex align-items-center">
              <CheckBox title="" :isChecked.sync="showToDate" @checkBoxClicked="toDateCheckBoxClicked" />
              <DateTimePicker
                placeholder="End Date"
                style="height: auto; top: 0"
                :value.sync="selectedToDate"
                :showTime="false"
                :errorMessage.sync="errorToDate"
                :isDisabled="!showToDate"
              />
            </div>
          </div>

          <div v-if="selectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'" class="active-filter-container">
            <Filters
              style="flex-basis: 120px"
              title="Equipment Category"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="selectedEquipmentCategory"
            />
          </div>

          <div
            v-if="selectedReportCode == 'STOCK_DAILY_MOVEMENT' || selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'"
            class="active-filter-container"
          >
            <Filters
              style="flex-basis: 80px"
              title="Warehouse"
              itemKey="Warehouse Code"
              :isFullScreen="true"
              :tableData="warehouseList"
              :selectedObject.sync="dailyWarehouseValue"
            />
            <Filters
              style="flex-basis: 80px"
              title="Product"
              itemKey="Product Code"
              :isFullScreen="true"
              :tableData="whProductList"
              :selectedObject.sync="dailyItemValue"
            />
            <Filters
              style="flex-basis: 80px"
              title="Product Group"
              itemKey="Part Group"
              :isFullScreen="true"
              :tableData="partGroupSet"
              :selectedObject.sync="dailyProductGroupValue"
            />
            <!-- <Filters
              style="flex-basis: 80px"
              title="Supplier"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="supplierList"
              :selectedObject.sync="dailySupplierValue"
            /> -->
          </div>

          <InputQuery
            placeholder="Vehicle"
            v-if="selectedReportCode == 'VEHICLE_AVAILABILITY'"
            class="mb-3"
            :isRequired="true"
            :items="vehicleList"
            :selectedObject.sync="vehicleAvailabilityVehicleValue"
            itemKey="label"
            :errorMessage.sync="vehicleAvailabilityVehicleValueError"
          />

          <div v-if="selectedReportCode == 'TYRE_USAGE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Vehicle"
              itemKey="label"
              :isFullScreen="true"
              :tableData="vehicleList"
              :selectedObject.sync="tyreUsageVehicleValue"
            />
            <Filters
              style="flex-basis: 100px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="tyreUsageVehicleTypeValue"
            />
          </div>

          <div v-if="selectedReportCode == 'JOB_ANALYSIS'" class="active-filter-container">
            <Dropdown
              placeholder="Report Type"
              :items="jobAnalysisTypes"
              :selectedObject.sync="jobAnalysisTypeValue"
              :errorMessage.sync="jobAnalysisTypeValueError"
              :isRequired="true"
              itemKey="label"
            />
            <Filters
              style="flex-basis: 120px"
              title="Vehicle"
              itemKey="label"
              :isFullScreen="true"
              :tableData="vehicleList"
              :selectedObject.sync="jobAnalysisVehicleValue"
            />
            <Filters
              style="flex-basis: 120px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="jobAnalysisVehicleTypeValue"
            />
          </div>

          <div v-if="selectedReportCode == 'PARTS_USAGE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Vehicle"
              itemKey="label"
              :isFullScreen="true"
              :tableData="vehicleList"
              :selectedObject.sync="partsUsageVehicleValue"
            />
            <Filters
              style="flex-basis: 100px"
              title="Part Type"
              itemKey="Part Type"
              :isFullScreen="true"
              :tableData="partTypeSet"
              :selectedObject.sync="partsUsagePartTypeValue"
            />
            <Filters
              style="flex-basis: 100px"
              title="Part Group"
              itemKey="Part Group"
              :isFullScreen="true"
              :tableData="partGroupSet"
              :selectedObject.sync="partsUsagePartGroupValue"
            />
          </div>

          <div v-if="selectedReportCode == 'MAINTENANCE'" class="active-filter-container">
            <Filters
              style="flex-basis: 100px"
              title="Vehicle Type"
              itemKey="CategoryCode"
              :isFullScreen="true"
              :tableData="equipmentCategoryList"
              :selectedObject.sync="maintenanceVehicleTypeValue"
            />
            <Input
              placeholder="Highlight Within (Days)"
              textType="number"
              :hasDecimal="false"
              :inputValue.sync="maintenanceHighlightDays"
            />
            <CheckBox
              title="Show Tasks"
              :isChecked.sync="maintenanceShowTasks"
              @checkBoxClicked="refreshMaintenanceTableData"
            />
          </div>

          <Button @click="refreshClicked" :disabled="!selectedReportName" class="mb-1">Refresh</Button>
        </div>
        <div class="filter-container" style="flex-shrink: 0">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Active Filters</div>

          <Input placeholder="Report Type" :isDisabled="true" :inputValue.sync="injectedReportName" />

          <div class="d-flex flex-column" v-if="injectedReportCode && !disableDateFieldsInjected">
            <div v-if="injectedDateField">{{ injectedDateField }}:</div>
            <DateTimePicker
              placeholder="Start Date"
              :isDisabled="true"
              :showTime="false"
              :value.sync="injectedFromDate"
              v-if="injectedFromDate"
            />
            <DateTimePicker
              placeholder="End Date"
              :isDisabled="true"
              :showTime="false"
              :value.sync="injectedToDate"
              v-if="injectedToDate"
            />
          </div>

          <div class="d-flex flex-column" v-if="injectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'">
            <Input placeholder="Equipment Category" :isDisabled="true" :inputValue.sync="injectedEquipmentCategory" />
          </div>
          <div
            class="d-flex flex-column"
            v-else-if="
              injectedReportCode == 'STOCK_DAILY_MOVEMENT' || selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'
            "
          >
            <Input placeholder="Warehouse" :isDisabled="true" :inputValue.sync="injectedDailyWarehouse" />
            <Input placeholder="Product" :isDisabled="true" :inputValue.sync="injectedDailyItem" />
            <Input placeholder="Product Group" :isDisabled="true" :inputValue.sync="injectedDailyProductGroup" />
            <!-- <Input placeholder="Supplier" :isDisabled="true" :inputValue.sync="injectedDailySupplier" /> -->
          </div>
          <Input
            :isDisabled="true"
            v-else-if="injectedReportCode == 'VEHICLE_AVAILABILITY'"
            placeholder="Vehicle"
            :inputValue.sync="injectedVehicleAvailabilityVehicle"
          />
          <div v-else-if="injectedReportCode == 'TYRE_USAGE'">
            <Input :isDisabled="true" placeholder="Vehicle" :inputValue.sync="injectedTyreUsageVehicle" />
            <Input :isDisabled="true" placeholder="Vehicle Type" :inputValue.sync="injectedTyreUsageVehicleType" />
          </div>

          <div v-else-if="injectedReportCode == 'JOB_ANALYSIS'">
            <Input placeholder="Report Type" :inputValue="injectedJobAnalysisType" :isDisabled="true" />
            <Input placeholder="Vehicle" :inputValue="injectedJobAnalysisVehicle" :isDisabled="true" />
            <Input placeholder="Vehicle Type" :inputValue="injectedJobAnalysisVehicleType" :isDisabled="true" />
          </div>

          <div v-else-if="injectedReportCode == 'PARTS_USAGE'">
            <Input placeholder="Vehicle" :isDisabled="true" :inputValue="injectedPartsUsageVehicle" />
            <Input placeholder="Part Type" :isDisabled="true" :inputValue="injectedPartsUsagePartType" />
            <Input placeholder="Part Group" :isDisabled="true" :inputValue="injectedPartsUsagePartGroup" />
          </div>
          <div v-else-if="injectedReportCode == 'MAINTENANCE'">
            <Input
              placeholder="Vehicle Type"
              :isDisabled="true"
              :inputValue="injectedMaintenanceVehicleTypeValue"
            />
            <Input
              placeholder="Highlight Within (Days)"
              :isDisabled="true"
              :inputValue="injectedMaintenanceHighlightDays"
            />
          </div>
        </div>
      </div>
      <div class="table-container">
        <TableBox
          :title="injectedReportName"
          :tableData="reportTableData"
          style="min-height: 0; min-width: 0"
          v-if="reportTableData"
          :hideColumns="tableHideFiltered"
          :groupBy="tableGroupBy"
          :lastRefreshed="lastRefreshed"
          :dataType="tableDataType"
          :allowEmptyNumeric="injectedReportCode == 'MAINTENANCE'"
        />
        <div v-if="reportTableData" class="d-flex align-items-center mt-2 w-100" style="gap: 8px">
          <div
            class="d-flex align-items-center"
            style="gap: 12px"
            v-if="injectedReportCode == 'EQUIPMENT_POLICY_EXPIRY'"
          >
            <div class="mr-1">Legend: </div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/error.png" />
              <div>Policy Expired</div>
            </div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/warning.png" />
              <div> Policy Expire in {{ settingvalue }} days</div>
            </div>
          </div>

          <div v-if="injectedReportCode == 'MAINTENANCE'" class="d-flex align-items-center" style="gap: 12px">
            <div class="mr-1">Legend:</div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/error.png" />
              <div>Overdue</div>
            </div>
            <div class="d-flex align-items-center" style="gap: 4px">
              <img style="height: 20px; width: 20px" src="https://dsmlib.logistics.systems/Icons/warning.png" />
              <div>Due within {{ injectedMaintenanceHighlightDays }} days</div>
            </div>
          </div>

          <div v-if="injectedReportCode == 'TYRE_USAGE'" class="d-flex" style="gap: 8px">
            Group By:
            <CheckBox
              title="Vehicle No"
              :isChecked.sync="tyreUsageGroupInventoryNo"
              @checkBoxClicked="tyreUsageGroupVehicleClick"
            />
            <CheckBox
              title="Serial No"
              :isChecked.sync="tyreUsageGroupSerialNo"
              @checkBoxClicked="tyreUsageGroupSerialClick"
            />
          </div>
          <div v-if="injectedReportCode == 'JOB_ANALYSIS' && injectedJobAnalysisType == 'Duration / Mileage Diff.'">
            <CheckBox
              title="Group Serial No"
              :isChecked.sync="jobAnalysisGroupByInventoryNo"
              @checkBoxClicked="refreshTableData"
            />
          </div>
        </div>
        <div v-else style="max-width: 420px; text-align: center; font-size: 1.25rem; width: 100%">
          <span> Enter Report Filters and click on <b>Refresh Table</b> to get started</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      reportNameData: [],
      dateFieldData: [],
      reportDateFieldsLoaded: false,
      equipmentCategoryList: [],
      policyTypes: [], // stores POLICYTYPE masterfile data
      reportTableData: null,
      selectedReportName: null,

      // Equipment Expiry Date
      selectedDateField: null,
      selectedEquipmentCategory: [],
      selectedFromDate: null,
      selectedToDate: null,

      // Stock Daily Movement
      dailyWarehouseValue: [],
      dailyItemValue: [],
      dailyProductGroupValue: [],
      dailySupplierValue: [],
      dailyFromDate: null,
      dailyToDate: null,

      // Vehicle Availability
      vehicleAvailabilityVehicleValue: null,
      vehicleAvailabilityVehicleValueError: '',

      // Tyre Usage
      tyreUsageVehicleValue: [],
      tyreUsageVehicleTypeValue: [],
      tyreUsageGroupSerialNo: false,
      tyreUsageGroupInventoryNo: false,
      tyreUsageTyreStatusTypes: [
        {
          label: 'All',
          keyValue: 'all',
        },
        { label: 'In Use', keyValue: '1' },
        { label: 'Retreading', keyValue: '3' },
        { label: 'Discard', keyValue: '4' },
        { label: 'Sent To Warehouse', keyValue: '5' },
        { label: 'Unavailable', keyValue: '0' },
      ],

      // Job Analysis
      jobAnalysisTypeValue: null,
      jobAnalysisTypeValueError: '',
      jobAnalysisVehicleValue: [],
      jobAnalysisVehicleTypeValue: [],
      jobAnalysisTypes: [
        {
          label: 'Duration / Mileage Diff.',
          keyValue: 'diff',
        },
        {
          label: 'Total Repair Count',
          keyValue: 'count',
        },
      ],
      jobAnalysisGroupByInventoryNo: false,

      // Parts Usage
      partsUsageVehicleValue: [],
      partsUsagePartTypeValue: [],
      partsUsagePartGroupValue: [],

      // Vehicle Maintenance
      maintenanceVehicleTypeValue: [],
      maintenanceHighlightDays: '1',
      maintenanceShowTasks: false,
      maintenanceReportGroups: [],

      warehouseList: [],
      whProductList: [],
      supplierList: [],
      vehicleList: [],
      emsparttypeList: [],

      settingvalue: '', // From GetSystemSetting (alert before expiry of policy)
      errorReportName: '',
      errorDateField: '',
      errorEquipmentCategory: '',
      errorFromDate: '',
      errorToDate: '',

      injectedReportName: '',
      injectedReportCode: '',

      injectedDateField: '',

      //Active stuff

      // Equipment Expiry Date active
      injectedEquipmentCategory: '',
      injectedFromDate: '',
      injectedToDate: '',

      // Stock Daily Movement active
      injectedDailyWarehouse: '',
      injectedDailyItem: '',
      injectedDailyProductGroup: '',
      injectedDailySupplier: '',
      injectedDailyFromDate: '',
      injectedDailyToDate: '',

      // Vehicle Availability active
      injectedVehicleAvailabilityVehicle: '',

      // Tyre Usage
      injectedTyreUsageVehicle: '',
      injectedTyreUsageVehicleType: '',

      // Job Analysis
      injectedJobAnalysisType: '',
      injectedJobAnalysisVehicle: '',
      injectedJobAnalysisVehicleType: '',

      // Parts Usage
      injectedPartsUsageVehicle: '',
      injectedPartsUsagePartType: '',
      injectedPartsUsagePartGroup: '',

      // Maintenance
      injectedMaintenanceVehicleTypeValue: '',
      injectedMaintenanceHighlightDays: '1',

      closeLeftTab: false,
      lastRefreshed: null,

      showFromDate: true,
      showToDate: false,

      tableHideColumns: [],

      stockMovementTableHide: ['prodtxnid'],
      jobAnalysisDiffTableHide: ['Vehicle No', 'Vehicle Code', 'Vehicle Category'],

      localCurrency: 'MYR',
      localCurrencyLoaded: false,

      tableDataType: {},

      expiryDataType: {
        'Equipment Category': 'string',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        'Chassis No': 'string',
        NCB: 'number',
        'Current Driver': 'string',
        'Lorry Length': 'number',
        'ROAD TAX': 'date',
        INSURANCE: 'date',
        PERMIT: 'date',
        INSPECTION: 'date',
      },

      stockDataType: {
        '#': 'number',
        Product: 'string',
        Warehouse: 'string',
        'Serial No': 'string',
        'Balance Before': 'number',
        [`Unit Price (${this.localCurrency})`]: 'currency',
        [`Total Cost (${this.localCurrency})`]: 'currency',
        'AP Invoice No': 'string',
        'AP Invoice Date': 'date',
        'Qty Received': 'number',
        'Qty Issued': 'number',
        'Qty Change': 'number',
        'Qty Balance': 'number',
        Date: 'date',
        'GR Job No': 'string',
        'Workshop Job No': 'string',
        'Vehicle No': 'string',
        Remarks: 'string',
      },

      vehicleAvailabilityDataType: {
        '#': 'number',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        Availability: 'string',
        Remark: 'string',
        'Audit Date': 'datetime',
        'Audit User': 'string',
      },
      tyreUsageDataType: {
        '#': 'number',
        'Vehicle No': 'string',
        'Serial No': 'string',
        Model: 'string',
        Manufacturer: 'string',
        'Made In': 'string',
        'Tyre Size': 'string',
        'No of Retread': 'number',
        'Tyre Position': 'string',
        'Tyre Status': 'string',
        'Mileage In Use': 'number',
        'Date Changed': 'date',
        'Days In Use': 'number',
        'Date Last Use': 'date',
        'Job No': 'string',
      },

      jobAnalysisDataType: {
        '#': 'number',
        'Total Repair Count': 'number',
        'Current Mileage': 'number',
        'Age of Vehicle (Year)': 'number',
        'Vehicle No': 'string',
        'Vehicle Code': 'string',
        'Vehicle Category': 'string',
        'Job No': 'string',
        'Job Date': 'date',
        Workshop: 'string',
        'Date In': 'date',
        'Time In': 'string',
        'Date Out': 'date',
        'Time Out': 'string',
        'Duration (Days)': 'number',
        Mileage: 'number',
        'Mileage Diff': 'number',
        'Service Person': 'string',
      },

      partUsageDataType: {
        '#': 'number',
        Vehicle: 'string',
        'Job No': 'string',
        'Job Date': 'datetime',
        'Part Type': 'string',
        'Part No': 'string',
        'Serial No': 'string',
        'Date Purchase': 'datetime',
        Supplier: 'string',
        Manufacturer: 'string',
        'Made In': 'string',
        Model: 'string',
        Size: 'string',
        Quantity: 'number',
        'Unit Price': 'currency',
        [`Cost (${this.localCurrency})`]: 'currency',
        Mileage: 'number',
        'Usage (KM)': 'number',
        'Date Out': 'date',
        'Tyre Position': 'string',
        'Invoice No': 'string',
      },

      maintenanceDataType: {
        '#': 'number',
        Vehicle: 'string',
        'Service / Task': 'string',
        Remarks: 'string',
        Due: 'string',
        'Current Mileage': 'number',
        'Mileage Interval': 'number',
        'Next Service Mileage': 'number',
        'Date Interval': 'string',
        'Next Service Date': 'date',
        Interval: 'string',
        Repeat: 'string',
        'Expiry Date': 'date',
        'Last Job No': 'string',
        'Job Date': 'date',
      },
    };
  },
  computed: {
    selectedReportCode() {
      return this.selectedReportName?.['ReportCode'] ?? null;
    },
    activeDateFields() {
      if (this.selectedReportCode == 'TYRE_USAGE') return [{ 'Report Key': 'TYRE_USAGE', 'Date Field': 'Date Changed' }];
      const filter = this.dateFieldData.filter((item) => item['Report Key'] == this.selectedReportCode);
      return filter;
    },
    disableDateFields() {
      const disableKeys = ['VEHICLE_AVAILABILITY', 'MAINTENANCE'];
      return disableKeys.includes(this.selectedReportCode);
    },
    disableDateFieldsInjected() {
      const disableKeys = ['VEHICLE_AVAILABILITY', 'MAINTENANCE'];
      return disableKeys.includes(this.injectedReportCode);
    },
    tableGroupBy() {
      if (this.selectedReportCode == 'TYRE_USAGE') {
        if (this.tyreUsageGroupSerialNo) return 'Serial No';
        else if (this.tyreUsageGroupInventoryNo) return 'Vehicle No';
      } else if (
        this.selectedReportCode == 'JOB_ANALYSIS' &&
        this.injectedJobAnalysisType == 'Duration / Mileage Diff.' &&
        this.jobAnalysisGroupByInventoryNo
      ) {
        return 'Vehicle No';
      }

      return '';
    },

    loginDetailsState() {
      return this.$store.state.loginDetails;
    },

    tableHideFiltered() {
      const reportCode = this.injectedReportCode;
      if (reportCode == 'JOB_ANALYSIS') {
        if (this.injectedJobAnalysisType == 'Duration / Mileage Diff.' && this.jobAnalysisGroupByInventoryNo) {
          return this.tableHideColumns;
        } else return [];
      } else if (reportCode == 'TYRE_USAGE') {
        if (this.tyreUsageGroupInventoryNo) return ['Vehicle No'];
      }
      return this.tableHideColumns;
    },

    partTypeSet() {
      const getPartType = this.emsparttypeList.map((item) => item['Part Type']).filter((item) => item);
      return [...new Set(getPartType)].map((item, index) => ({ '#': index + 1, 'Part Type': item }));
    },
    partGroupSet() {
      const getGroupType = this.emsparttypeList.map((item) => item['Part Group']).filter((item) => item);
      return [...new Set(getGroupType)].map((item, index) => ({ '#': index + 1, 'Part Group': item }));
    },
  },
  props: {},
  methods: {
    fromDateCheckBoxClicked: function () {
      if (this.showFromDate == false && this.showToDate == false) {
        this.showToDate = true;
      }
    },
    toDateCheckBoxClicked: function () {
      if (this.showFromDate == false && this.showToDate == false) {
        this.showFromDate = true;
      }
    },
    refreshClearFilter: function () {
      this.injectedReportName = '';
      this.injectedDateField = '';
      this.injectedEquipmentCategory = '';
      this.injectedFromDate = '';
      this.injectedToDate = '';
    },

    tyreUsageGroupSerialClick() {
      this.tyreUsageGroupInventoryNo = false;
      this.refreshTableData();
    },

    tyreUsageGroupVehicleClick() {
      this.tyreUsageGroupSerialNo = false;
      this.refreshTableData();
    },

    refreshTableData() {
      const refresh = this.reportTableData;
      this.reportTableData = [];
      this.$nextTick(() => {
        this.reportTableData = refresh;
      });
    },

    refreshMaintenanceTableData() {
      const rows = this.maintenanceReportGroups.flatMap((group) => {
        return this.maintenanceShowTasks ? [group.parent, ...group.tasks] : [group.parent];
      });
      this.reportTableData = [];
      this.$nextTick(() => {
        this.reportTableData = rows;
      });
    },
    errorDateFieldCheck: function () {
      if (!this.selectedDateField || Object.keys(this.selectedDateField).length === 0) {
        this.errorDateField = 'Please select a Date Field';
        return true;
      }
      return false;
    },
    errorDatePickerCheck: function () {
      if (this.selectedFromDate == null && this.selectedToDate == null) return true;

      if (this.selectedFromDate != null && this.selectedToDate != null) {
        if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
          this.errorFromDate = 'From Date > To Date';
          this.errorToDate = 'From Date > To Date';
          return true;
        }
      }
      return false;
    },

    errorReportNameCheck: function () {
      if (!this.selectedReportName || Object.keys(this.selectedReportName).length === 0) {
        this.errorReportName = 'Please select a Report Name';
        return true;
      }
      return false;
    },

    refreshClicked: async function () {
      if (this.errorReportNameCheck()) return;

      this.tableHideColumns = [];
      this.tableDataType = {};

      this.injectedFromDate = this.showFromDate ? this.selectedFromDate : null;
      this.injectedToDate = this.showToDate ? this.selectedToDate : null;

      const formattedStartDate = this.selectedFromDate?.formatString('yyyy-MM-dd') ?? null;
      const formattedEndDate = this.selectedToDate?.formatString('yyyy-MM-dd') ?? null;

      if (
        this.selectedReportCode == 'TYRE_USAGE' &&
        this.showFromDate &&
        this.showToDate &&
        this.selectedFromDate &&
        this.selectedToDate &&
        this.selectedFromDate.getTime() > this.selectedToDate.getTime()
      ) {
        this.errorFromDate = 'From Date > To Date';
        this.errorToDate = 'From Date > To Date';
        return;
      }

      if (this.selectedReportCode == 'EQUIPMENT_POLICY_EXPIRY') {
        if (this.errorDateFieldCheck() || this.errorDatePickerCheck()) {
          this.$fullscreenLoading();
          this.$showAlert('error', 'Filters are incomplete');
          return;
        }

        this.$fullscreenLoading('Refreshing');
        this.reportTableData = [];

        this.injectedEquipmentCategory =
          this.selectedEquipmentCategory.length > 0 ?
            this.selectedEquipmentCategory
              .map((category) => {
                return category['CategoryCode'];
              })
              .join(', ')
          : 'All';

        this.$fullscreenLoading('Getting Table');

        const expiryResult = await this.$apiCallV2('/EquipmentReport/GetEquipmentPolicyExpiryDate', {
          fromdate: this.showFromDate ? formattedStartDate : '',
          todate: this.showToDate ? formattedEndDate : '',
          equipmentcategorylist:
            this.selectedEquipmentCategory.length > 0 ?
              this.selectedEquipmentCategory.map((category) => {
                return category['CategoryCode'];
              })
            : null,
        });
        this.reportTableData = expiryResult.map((item) => {
          const { ['Inventory No']: vehicleNo, ...rest } = item;
          return {
            ...rest,
            'Vehicle No': vehicleNo ?? '',
          };
        });

        const currentDate = new Date();
        for (let policyData of this.reportTableData) {
          for (let policy of this.policyTypes) {
            if (!policyData[policy['PolicyType']]) {
              continue;
            }

            if (
              (new Date(policyData[policy['PolicyType']]) - currentDate) / (1000 * 3600 * 24) <= this.settingvalue &&
              (new Date(policyData[policy['PolicyType']]) - currentDate) / (1000 * 3600 * 24) >= 0
            ) {
              policyData[policy['PolicyType']] =
                `${policyData[policy['PolicyType']]} <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/warning.png">`;
            } else if (currentDate >= new Date(policyData[policy['PolicyType']])) {
              policyData[policy['PolicyType']] =
                `${policyData[policy['PolicyType']]} <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/error.png">`;
            }
          }
        }
        this.tableDataType = {
          ...this.expiryDataType,
          ...this.policyTypes.reduce((dataType, policy) => {
            dataType[policy['PolicyType']] = 'date';
            return dataType;
          }, {}),
        };
      } else if (
        this.selectedReportCode == 'STOCK_DAILY_MOVEMENT' ||
        this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL'
      ) {
        this.$fullscreenLoading('Getting Stock Movement...');
        let type = '';
        if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT') type = 'SUMMARY';
        else if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL') type = 'DETAIL';

        const requestWarehouse =
          this.dailyWarehouseValue.length > 0 ?
            this.dailyWarehouseValue.map((warehouse) => warehouse['Warehouse Code']).join(',')
          : null;
        const requestItem =
          this.dailyItemValue.length > 0 ? this.dailyItemValue.map((item) => item['Product Code']).join(',') : null;
        const requestProductGroup =
          this.dailyProductGroupValue.length > 0 ?
            this.dailyProductGroupValue.map((item) => item['Part Group']).join(',')
          : null;

        const result = await this.$apiCallV2('/EquipmentReport/PrintStockMovement', {
          type: type,
          startdate: this.showFromDate ? formattedStartDate : null,
          enddate: this.showToDate ? formattedEndDate : null,
          warehouse: requestWarehouse,
          item: requestItem,
          partgroup: requestProductGroup,
        });

        this.injectedDailyWarehouse = requestWarehouse ?? 'All';
        this.injectedDailyItem = requestItem ?? 'All';
        this.injectedDailyProductGroup = requestProductGroup ?? 'All';
        this.injectedDailySupplier =
          this.dailySupplierValue.length > 0 ?
            this.dailySupplierValue.map((supplier) => supplier['Supplier Code']).join(', ')
          : 'All';

        let updateTable = [];

        if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT')
          updateTable = result.map((item, index) => {
            const { ProdCode, Name, WhseCode, BatchNo, QtyReceived, QtyIssued, BalanceBefore, UnitPrice, APInvNo, APInvDate } = item;
            const qtyRec = Number(QtyReceived ?? 0);
            const qtyIss = Number(QtyIssued ?? 0);
            const qtyMove = qtyRec - qtyIss;
            const qtyBal = Number(BalanceBefore ?? 0) + qtyMove;
            const unitPrice = UnitPrice == null ? '' : Number(UnitPrice);
            const totalCost = unitPrice === '' ? '' : qtyBal * unitPrice;

            const findWhse = this.warehouseList.find((warehouse) => warehouse['Warehouse Code'] == WhseCode);
            const { Name: whseName } = findWhse || {};
            return {
              '#': index + 1,
              Product: `[${ProdCode}] ${Name}`,
              Warehouse: WhseCode ? `[${WhseCode}] ${whseName ?? ''}` : '',
              'Serial No': BatchNo,
              [`Unit Price (${this.localCurrency})`]: unitPrice,
              [`Total Cost (${this.localCurrency})`]: totalCost,
              'AP Invoice No': APInvNo || '',
              'AP Invoice Date': APInvDate || '',
              'Balance Before': BalanceBefore,
              'Qty Received': qtyRec,
              'Qty Issued': qtyIss,
              'Qty Change': qtyMove,
              'Qty Balance': qtyBal,
            };
          });
        else if (this.selectedReportCode == 'STOCK_DAILY_MOVEMENT_DETAIL')
          updateTable = result.map((item, index) => {
            const {
              ProdCode,
              Name,
              WhseCode,
              BatchNo,
              Date: movDate,
              QtyReceived,
              QtyIssued,
              JobNo,
              GRJobNo,
              WorkshopJobNo,
              VehicleNo,
              Spp_Code: SppCode,
              UnitPrice,
              APInvNo,
              APInvDate,
              Remarks,
            } = item;
            const qtyRec = Number(QtyReceived ?? 0);
            const qtyIss = Number(QtyIssued ?? 0);
            const unitPrice = UnitPrice == null ? '' : Number(UnitPrice);
            const qtyMove = qtyRec - qtyIss;
            const totalCost = unitPrice === '' ? '' : qtyMove * unitPrice;

            const findWhse = this.warehouseList.find((warehouse) => warehouse['Warehouse Code'] == WhseCode);
            const { Name: whseName } = findWhse || {};

            const findSpp = this.supplierList.find((supplier) => supplier['Supplier Code'] == SppCode);
            const { 'Supplier Name': sppName } = findSpp || {};
            const vehicleNo = (VehicleNo ?? '').trim();
            const findVehicle = vehicleNo ? this.vehicleList.find((vehicle) =>
              vehicle['Inventory #'] == vehicleNo || vehicle['Inventory Code'] == vehicleNo,
            ) : null;
            return {
              '#': index + 1,
              Product: `[${ProdCode}] ${Name}`,
              Warehouse: WhseCode ? `[${WhseCode}] ${whseName ?? ''}` : '',
              'Serial No': BatchNo,
              Date: movDate,
              [`Unit Price (${this.localCurrency})`]: unitPrice,
              [`Total Cost (${this.localCurrency})`]: totalCost,
              'Qty Received': qtyRec || '',
              'Qty Issued': qtyIss || '',
              'Supplier': SppCode ? `[${SppCode}] ${sppName ?? ''}` : '',
              'GR Job No': GRJobNo || JobNo || '',
              'Workshop Job No': WorkshopJobNo || '',
              'Vehicle No': findVehicle ? findVehicle.label : VehicleNo,
              Remarks: Remarks || '',
              'AP Invoice No': APInvNo || '',
              'AP Invoice Date': APInvDate || '',
            };
          });

        this.tableHideColumns = this.stockMovementTableHide.concat(
          !this.showFromDate ? ['Balance Before', 'Qty Change', 'Qty Balance'] : [],
        );
        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = updateTable;
        });
        this.tableDataType = this.stockDataType;
      } else if (this.selectedReportCode == 'VEHICLE_AVAILABILITY') {
        this.vehicleAvailabilityVehicleValueError = '';

        let error = false;
        if (!this.vehicleAvailabilityVehicleValue) {
          this.vehicleAvailabilityVehicleValueError = 'Vehicle is required';
          error = true;
        }
        if (error) return;

        this.$fullscreenLoading('Getting Vehicle Availability History...');

        const { label: vehicleLabel, 'Inventory #': vehicleNo } = this.vehicleAvailabilityVehicleValue || {};
        this.injectedVehicleAvailabilityVehicle = vehicleLabel;

        const result = await this.$apiCallV2('/EquipmentReport/GetVehicleAvailabilityHistory', {
          vehicleno: vehicleNo,
        });

        const returnData = result.map((item, index) => {
          const { VehicleNo, VehicleCode, Availability, Remark1, AuditDate, AuditUserID } = item;
          return {
            '#': index + 1,
            'Vehicle No': VehicleNo,
            'Vehicle Code': VehicleCode,
            Availability: Availability == '1' ? 'Yes' : 'No',
            Remark: index == 0 ? 'First created' : Remark1,
            'Audit Date': AuditDate,
            'Audit User': AuditUserID,
          };
        });

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = returnData;
        });
        this.tableDataType = this.vehicleAvailabilityDataType;
      } else if (this.selectedReportCode == 'TYRE_USAGE') {
        let error = false;

        if (error) return;

        this.$fullscreenLoading('Getting Tyre Usage History...');

        const selectedVehicles =
          this.tyreUsageVehicleValue.length > 0 ?
            this.tyreUsageVehicleValue.map((item) => item['Inventory #']).join(',')
          : null;
        this.injectedTyreUsageVehicle = selectedVehicles ?? 'All';

        const selectedVehicleType =
          this.tyreUsageVehicleTypeValue.length > 0 ?
            this.tyreUsageVehicleTypeValue.map((item) => item['Category Code']).join(',')
          : null;
        this.injectedTyreUsageVehicleType = selectedVehicleType ?? 'All';

        const result = await this.$apiCallV2(`/EquipmentReport/GetVehicleTyreUsage`, {
          vehicleno: selectedVehicles,
          vehicletype: selectedVehicleType,
          startdate: this.showFromDate && this.selectedFromDate ? this.selectedFromDate.formatString('yyyy-MM-dd') : null,
          enddate: this.showToDate && this.selectedToDate ? this.selectedToDate.formatString('yyyy-MM-dd') : null,
        });
        const order = result.map((item, index) => {
          const {
            VehicleNo,
            SerialNo,
            Model,
            Manufacturer,
            MadeIn,
            TyreSize,
            TyrePosition,
            InUse,
            StartMileage,
            EndMileage,
            DateLastUse,
            DateChange,
            NoOfRetread,
            JobNo,
          } = item;

          const mileageInUse = Number(EndMileage ?? 0) - Number(StartMileage ?? 0);
          const dateInUse = Date.parse(DateChange) - Date.parse(DateLastUse);
          const { label: InUseLabel } = this.tyreUsageTyreStatusTypes.find((item) => item.keyValue == InUse) || {};

          const { 'Inventory Code': InventoryCode } = this.vehicleList.find((item) => item['Inventory #'] == VehicleNo);

          return {
            '#': index + 1,
            'Vehicle No': [VehicleNo, InventoryCode].filter((value) => value).join(' - '),
            'Serial No': SerialNo,
            Model: Model,
            Manufacturer: Manufacturer ?? '',
            'Made In': MadeIn ?? '',
            'Tyre Size': TyreSize ?? '',
            'No of Retread': NoOfRetread ?? '',
            'Tyre Position': TyrePosition ?? '',
            'Tyre Status': InUseLabel ?? '',
            'Mileage In Use': mileageInUse,
            'Date Changed': DateChange ? new Date(DateChange).formatString('yyyy-MM-dd') : '',
            'Days In Use': Math.round(dateInUse / (1000 * 60 * 60 * 24)),
            'Date Last Use': DateLastUse ? new Date(DateLastUse).formatString('yyyy-MM-dd') : '',
            'Job No': JobNo,
          };
        });

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = order;
        });
        this.tableDataType = this.tyreUsageDataType;
      } else if (this.selectedReportCode == 'JOB_ANALYSIS') {
        this.jobAnalysisTypeValueError = '';
        let error = false;
        if (!this.jobAnalysisTypeValue) {
          this.jobAnalysisTypeValueError = 'Report Type is required';
          error = true;
        }
        if (error) return;

        this.$fullscreenLoading('Getting Job Analysis...');

        const { label, keyValue: reportType } = this.jobAnalysisTypeValue || {};

        this.injectedJobAnalysisType = label;

        const vehicleType =
          this.jobAnalysisVehicleTypeValue.length > 0 ?
            this.jobAnalysisVehicleTypeValue
              .map((category) => {
                return category['CategoryCode'];
              })
              .join(',')
          : null;
        const selectedVehicles = this.jobAnalysisVehicleValue.length > 0 ? this.jobAnalysisVehicleValue : [];
        const vehicleNo = selectedVehicles.length > 0 ? selectedVehicles.map((item) => item['Inventory #']).join(',') : null;
        this.injectedJobAnalysisVehicleType = vehicleType ?? 'All';
        this.injectedJobAnalysisVehicle =
          selectedVehicles.length > 0 ? selectedVehicles.map((item) => item.label).join(', ') : 'All';

        const result = await this.$apiCallV2(`/EquipmentReport/GetJobAnalysis`, {
          type: reportType,
          startdate: this.injectedFromDate || null,
          enddate: this.injectedToDate || null,
          vehicleno: vehicleNo,
          vehicletype: vehicleType,
        });

        let order = [];

        if (reportType == 'diff') {
          order = result.map((item, index) => {
            const {
              InventoryNo,
              InventoryCode,
              CategoryDesc,
              JobNo,
              JobDate,
              Workshop,
              DateIn,
              TimeIn,
              DateOut,
              TimeOut,
              Amount,
              MeterReading,
              ServicePerson,
            } = item;
            const duration =
              DateOut ? Math.ceil(Math.abs(Date.parse(DateOut) - Date.parse(DateIn)) / (1000 * 60 * 60 * 24)) : '';
            const findNext = index < result.length - 1 ? result[index + 1] : null;
            const nextMileage = findNext?.InventoryNo == InventoryNo ? findNext.MeterReading : null;

            return {
              '#': index + 1,
              'Vehicle No': InventoryNo,
              'Vehicle Code': InventoryCode,
              'Vehicle Category': CategoryDesc,
              'Job No': JobNo,
              'Job Date': JobDate,
              Workshop: Workshop,
              'Date In': DateIn,
              'Time In': TimeIn,
              'Date Out': DateOut ?? '',
              'Time Out': DateOut && TimeIn ? TimeIn : '',
              'Duration (Days)': duration,
              [`Amount (${this.localCurrency})`]: Amount,
              Mileage: MeterReading,
              'Mileage Diff': nextMileage ? MeterReading - nextMileage : '',
              'Service Person': ServicePerson,
            };
          });
        } else if (reportType == 'count') {
          order = result.map((item) => {
            const { InventoryNo, InventoryCode, CategoryDesc, RepairCount, TotalAmount, CurrentMileage, DatePurchase } =
              item;

            return {
              'Vehicle No': InventoryNo,
              'Vehicle Code': InventoryCode,
              'Vehicle Category': CategoryDesc,
              'Total Repair Count': RepairCount,
              [`Total Amount (${this.localCurrency})`]: TotalAmount,
              'Current Mileage': CurrentMileage,
              'Age of Vehicle (Year)': DatePurchase ? this.getAge(DatePurchase) : '',
            };
          });
        }

        this.tableHideColumns = this.jobAnalysisDiffTableHide;

        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = order;
        });

        this.tableDataType = {
          ...this.jobAnalysisDataType,
          [`Total Amount (${this.localCurrency})`]: 'currency',
          [`Amount (${this.localCurrency})`]: 'currency',
        };
      } else if (this.selectedReportCode == 'PARTS_USAGE') {
        const partTypeString =
          this.partsUsagePartTypeValue?.length > 0 ?
            this.partsUsagePartTypeValue.map((item) => item['Part Type']).join(',')
          : null;
        const partGroupString =
          this.partsUsagePartGroupValue?.length > 0 ?
            this.partsUsagePartGroupValue.map((item) => item['Part Group']).join(',')
          : null;
        const selectedVehicles = this.partsUsageVehicleValue?.length > 0 ? this.partsUsageVehicleValue : [];
        const vehicleNo = selectedVehicles.length > 0 ? selectedVehicles.map((item) => item['Inventory #']).join(',') : null;

        this.injectedPartsUsageVehicle =
          selectedVehicles.length > 0 ? selectedVehicles.map((item) => item.label).join(', ') : 'All';
        this.injectedPartsUsagePartType = partTypeString ?? 'All';
        this.injectedPartsUsagePartGroup = partGroupString ?? 'All';

        this.$fullscreenLoading('Getting Parts Usage...');
        const data = await this.$apiCallV2(`/EquipmentReport/GetPartsUsage`, {
          startdate: this.injectedFromDate || null,
          enddate: this.injectedToDate || null,
          vehicleno: vehicleNo,
          parttype: partTypeString,
          partgroup: partGroupString,
        });

        const filterData = data.map((item, index) => {
          const {
            InventoryNo,
            VehicleCode,
            JobNo,
            JobDate,
            PartType,
            PartNo,
            SerialNo,
            DatePurchase,
            Supplier,
            Manufacturer,
            MadeIn,
            Model,
            Size,
            Quantity,
            Cost,
            MileageUse,
            MileageDiff,
            DateOut,
            TyreIndex,
            TyreNaming,
            InvoiceNo,
          } = item;
          const { tyrePosition } = TyreIndex ? this.tyrePositionInfo(TyreIndex) : '';

          return {
            '#': index + 1,
            Vehicle: [InventoryNo, VehicleCode].filter((value) => value).join(' - '),
            'Job No': JobNo ?? '',
            'Job Date': JobDate,
            'Part Type': PartType ?? '',
            'Part No': PartNo ?? '',
            'Serial No': SerialNo ?? '',
            'Date Purchase': DatePurchase,
            Supplier: Supplier ?? '',
            Manufacturer: Manufacturer ?? '',
            'Made In': MadeIn ?? '',
            Model: Model ?? '',
            Size: Size ?? '',
            Quantity: Quantity ?? '',
            'Unit Price': Cost && Quantity ? this.$currencyFormat((Number(Cost) / Number(Quantity)).toString()) : '',
            [`Cost (${this.localCurrency})`]: Cost ? this.$currencyFormat(Number(Cost).toString()) : '',
            Mileage: MileageUse ?? '',
            'Usage (KM)': MileageDiff ?? '',
            'Date Out': DateOut ?? '',
            'Tyre Position': (TyreNaming || tyrePosition) ?? '',
            'Invoice No': InvoiceNo,
          };
        });
        this.reportTableData = [];
        this.$nextTick(() => {
          this.reportTableData = filterData;
        });

        this.tableDataType = this.partUsageDataType;
      } else if (this.selectedReportCode == 'MAINTENANCE') {
        this.$fullscreenLoading('Getting Maintenance...');

        const selectedVehicleType =
          this.maintenanceVehicleTypeValue.length > 0 ?
            this.maintenanceVehicleTypeValue.map((item) => item['CategoryCode']).join(',')
          : null;
        const highlightWithinDays = Math.max(Number(this.maintenanceHighlightDays) || 0, 0);
        this.injectedMaintenanceVehicleTypeValue = selectedVehicleType ?? 'All';
        this.injectedMaintenanceHighlightDays = String(highlightWithinDays);

        const data = await this.$apiCallV2(`/EquipmentReport/GetMaintanceList`, {
          vehicletype: selectedVehicleType,
        });
        const maintenanceItems = data.map((item) => {
          const {
            InventoryNo,
            VehicleCode,
            ServiceCode,
            ServiceDesc,
            Task,
            TaskDesc,
            Remark,
            MeterReading: meterreading,
            LastJobMileage,
            Duration,
            Mileage,
            Repetitive,
            ExpireDate,
            JobNo,
            JobDate,
            LastServiceDate,
            SerVariant,
            DateCreated,
            DatePurchase,
          } = item;
          const serviceVariant = String(SerVariant ?? '');
          const MeterReading = meterreading ?? 0;
          const nextMileage = Number(Mileage) + Number(LastJobMileage || 0);
          const hasMileageInterval = Mileage !== null && Mileage !== undefined && Mileage !== '';
          const durationString =
            serviceVariant == '1' || serviceVariant == '3' ? `${Duration} Months`
            : serviceVariant == '2' ? `${Duration} Days`
            : '';
          const getNextDuration = () => {
            const startDateString = LastServiceDate ?? JobDate ?? DateCreated ?? DatePurchase;
            if (!startDateString || !Duration) return '';
            const durationNum = Number(Duration);
            const nextDate = new Date(startDateString);
            if (serviceVariant == '1' || serviceVariant == '3') nextDate.setMonth(nextDate.getMonth() + durationNum);
            else if (serviceVariant == '2') nextDate.setDate(nextDate.getDate() + durationNum);
            else return '';
            if (isNaN(nextDate.getTime())) return '';
            return new Date(nextDate);
          };
          const getNextDurationString = () => {
            const date = getNextDuration();
            return date ? date.formatString('yyyy-MM-dd') : '';
          };
          const dueStatus = () => {
            if (JobNo && Repetitive == '0') return 'none';
            if (hasMileageInterval && ['0', '3'].includes(serviceVariant) && Number(MeterReading) >= nextMileage) {
              return 'overdue';
            }
            const nextDuration = getNextDuration();
            if (!nextDuration) return 'none';

            const currentDate = new Date();
            if (currentDate >= new Date(nextDuration)) return 'overdue';

            const daysToService = (new Date(nextDuration) - currentDate) / (1000 * 3600 * 24);
            return daysToService <= highlightWithinDays ? 'upcoming' : 'none';
          };
          const status = dueStatus();
          const due =
            status == 'overdue' ?
              'Yes <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/error.png">'
            : status == 'upcoming' ?
              'Yes <img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/warning.png">'
            : 'No';

          const SerVariantString = () => {
            if (serviceVariant == '0') return 'Mileage';
            else if (serviceVariant == '1') return 'Months';
            else if (serviceVariant == '2') return 'Days';
            else if (serviceVariant == '3') return 'Which Comes First';
          };
          return {
            groupKey: JSON.stringify([
              InventoryNo,
              ServiceCode,
              serviceVariant,
              Mileage,
              Duration,
              Repetitive,
              ExpireDate,
            ]),
            status: status,
            lastServiceDate: LastServiceDate ?? JobDate,
            taskCode: Task,
            taskDescription: TaskDesc,
            row: {
              '#': '',
              Vehicle: [InventoryNo, VehicleCode].filter((value) => value).join(' - '),
              'Service / Task': `[${ServiceCode}] ${ServiceDesc}`,
              Remarks: Remark ?? '',
              Due: due,
              'Current Mileage': MeterReading ?? '',
              'Mileage Interval': Mileage ?? '',
              'Next Service Mileage': hasMileageInterval && ['0', '3'].includes(serviceVariant) ? nextMileage : '',
              'Date Interval': Duration ? durationString : '',
              'Next Service Date': Duration ? getNextDurationString() : '',
              Interval: SerVariantString(),
              Repeat: Repetitive == '1' ? 'Routine' : 'Once Only',
              'Expiry Date': ExpireDate ? new Date(ExpireDate).formatString('yyyy-MM-dd') : '',
              'Last Job No': JobNo ?? '',
              'Job Date': JobDate ? new Date(JobDate).formatString('yyyy-MM-dd') : '',
            },
          };
        });

        const groups = [];
        const groupsByKey = {};
        maintenanceItems.forEach((item) => {
          if (!groupsByKey[item.groupKey]) {
            groupsByKey[item.groupKey] = { items: [] };
            groups.push(groupsByKey[item.groupKey]);
          }
          groupsByKey[item.groupKey].items.push(item);
        });

        const statusPriority = { none: 0, upcoming: 1, overdue: 2 };
        this.maintenanceReportGroups = groups.map((group, index) => {
          const mostUrgentItem = group.items.reduce((current, item) => {
            return statusPriority[item.status] > statusPriority[current.status] ? item : current;
          });
          const lastJobItem = group.items.reduce((latest, item) => {
            if (!item.row['Last Job No']) return latest;
            if (!latest) return item;
            const itemDate = new Date(item.lastServiceDate || 0).getTime() || 0;
            const latestDate = new Date(latest.lastServiceDate || 0).getTime() || 0;
            return itemDate > latestDate ||
              (itemDate == latestDate && item.row['Last Job No'] > latest.row['Last Job No']) ? item : latest;
          }, null);
          const parent = {
            ...group.items[0].row,
            '#': index + 1,
            Remarks: '',
            Due: mostUrgentItem.row.Due,
            'Next Service Date': mostUrgentItem.row['Next Service Date'],
            'Last Job No': lastJobItem?.row['Last Job No'] || '',
            'Job Date': lastJobItem?.row['Job Date'] || '',
          };
          const tasks = group.items.map((item) => {
            return {
              ...item.row,
              '#': '',
              Vehicle: '',
              'Service / Task': `[${item.taskCode}] ${item.taskDescription}`,
              Due: '',
              'Current Mileage': '',
              'Mileage Interval': '',
              'Next Service Mileage': '',
              'Date Interval': '',
              'Next Service Date': '',
              Interval: '',
              Repeat: '',
              'Expiry Date': '',
              'Last Job No': '',
              'Job Date': '',
            };
          });
          return { parent, tasks };
        });
        this.refreshMaintenanceTableData();

        this.tableDataType = this.maintenanceDataType;
      }

      this.injectedReportName = this.selectedReportName['Report'];
      this.injectedReportCode = this.selectedReportName['ReportCode'];

      this.injectedDateField = this.selectedDateField?.['Date Field'] ?? '';

      this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');

      this.$fullscreenLoading();

      this.filtersIsCollapsed = true;
    },

    async reportSelected() {
      this.resetDateFields();
      const reportCode = this.selectedReportCode;
      if (!reportCode) return;

      this.$fullscreenLoading('Getting Report Filters');
      try {
        const requests = [];
        const ensure = (list, fetch) => {
          if (!Array.isArray(list) || list.length == 0) requests.push(fetch.call(this));
        };

        const usesDateFields = [
          'EQUIPMENT_POLICY_EXPIRY',
          'STOCK_DAILY_MOVEMENT',
          'STOCK_DAILY_MOVEMENT_DETAIL',
          'JOB_ANALYSIS',
          'PARTS_USAGE',
        ].includes(reportCode);
        if (usesDateFields && !this.reportDateFieldsLoaded)
          requests.push(this.getReportDateFields());

        if (reportCode == 'EQUIPMENT_POLICY_EXPIRY') {
          ensure(this.equipmentCategoryList, this.getEquipmentCategoryList);
          if (!this.settingvalue) requests.push(this.getSystemSettings());
        } else if (reportCode == 'STOCK_DAILY_MOVEMENT' || reportCode == 'STOCK_DAILY_MOVEMENT_DETAIL') {
          ensure(this.warehouseList, this.getWarehouseList);
          ensure(this.whProductList, this.getwhProductList);
          ensure(this.emsparttypeList, this.getPartsType);
          ensure(this.supplierList, this.getSupplierList);
          if (reportCode == 'STOCK_DAILY_MOVEMENT_DETAIL') ensure(this.vehicleList, this.getVehicleList);
        } else if (reportCode == 'VEHICLE_AVAILABILITY') {
          ensure(this.vehicleList, this.getVehicleList);
        } else if (reportCode == 'TYRE_USAGE') {
          ensure(this.vehicleList, this.getVehicleList);
          ensure(this.equipmentCategoryList, this.getEquipmentCategoryList);
        } else if (reportCode == 'JOB_ANALYSIS') {
          ensure(this.vehicleList, this.getVehicleList);
          ensure(this.equipmentCategoryList, this.getEquipmentCategoryList);
        } else if (reportCode == 'PARTS_USAGE') {
          ensure(this.vehicleList, this.getVehicleList);
          ensure(this.emsparttypeList, this.getPartsType);
          if (!this.localCurrencyLoaded) requests.push(this.getLocalCurrency());
        } else if (reportCode == 'MAINTENANCE') {
          ensure(this.equipmentCategoryList, this.getEquipmentCategoryList);
        }

        await Promise.all(requests);
        this.resetDateFields();
      } finally {
        this.$fullscreenLoading();
      }
    },

    resetDateFields() {
      this.selectedDateField = this.activeDateFields[0];
    },

    //fetch data
    async getReportNameList() {
      this.reportNameData = await this.$apiCallV2('/EquipmentReport/GetListMaster?masterfile=RPT_REPORT&module=EMS');
    },

    async getReportDateFields() {
      this.dateFieldData = await this.$apiCallV2(
        '/EquipmentReport/GetListMaster?masterfile=RPT_REPORT_DATEFIELD&module=EMS',
      );
      this.reportDateFieldsLoaded = true;
    },

    async getEquipmentCategoryList() {
      this.equipmentCategoryList = await this.$apiCallV2('/EquipmentReport/GetVehicleCategory');
    },

    async getSystemSettings() {
      this.settingvalue = await this.$apiCallV2('/EquipmentReport/GetSettingsSystem?settingsitem=DrvExpAlertDays');
      this.settingvalue = this.settingvalue[0]['SettingsValue'];
      if (this.settingvalue == null || this.settingvalue == '') this.settingvalue = 7;
    },

    async getWarehouseList() {
      this.warehouseList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'WAREHOUSE' });
    },

    async getwhProductList() {
      this.whProductList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'WHPRODUCT' });
    },

    async getSupplierList() {
      this.supplierList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SUPPLIER' });
    },
    async getVehicleList() {
      this.vehicleList = (await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLE' })).map((item) => {
        const { 'Inventory #': InventoryNo, 'Inventory Code': InventoryCode } = item;
        return {
          ...item,
          label: [InventoryNo, InventoryCode].filter((value) => value).join(' - '),
        };
      });
    },

    async getPartsType() {
      this.emsparttypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMSPARTTYPE' });
    },

    async getLocalCurrency() {
      const companyDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'COMPANY',
        module: 'MASTER',
        recordid: this.$store.state.loginDetails.CoCode,
      });
      if (companyDetails.CompanyLocalCur) this.localCurrency = companyDetails.CompanyLocalCur;
      this.localCurrencyLoaded = true;
    },

    //helper
    getAge(dateString) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();

      // Check if the birthday has occurred yet this year
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return age;
    },

    tyrePositionInfo(tyreIndex) {
      const align =
        tyreIndex <= 49 ? 'L'
        : tyreIndex <= 99 ? 'R'
        : 'S';

      const rowNo = tyreIndex < 100 ? (tyreIndex % 10) + 1 : 0;

      let tyrePosition = '';
      if (align == 'L') {
        tyrePosition = rowNo >= 1 && rowNo <= 5 ? 'FL' : 'RL';
      } else if (align == 'R') {
        tyrePosition = rowNo >= 1 && rowNo <= 5 ? 'FR' : 'RR';
      } else if (align == 'S') {
        tyrePosition = 'SP';
      } else {
        tyrePosition = rowNo == 0 ? 'FC' : 'RC';
      }

      let columnNo = 0;
      if (tyreIndex < 100) {
        const strIndex = tyreIndex.toString();
        const firstDigit = strIndex.length == 1 ? 0 : parseInt(strIndex[0], 10);
        columnNo = firstDigit + 1;
      }

      return { align, tyrePosition, rowNo, columnNo };
    },
  },
  async mounted() {
    this.closeLeftTab = false;
    // this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');

    var date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.$fullscreenLoading('Getting Report Types');
    await this.getReportNameList();
    this.$fullscreenLoading();
  },
  watch: {
    loginDetailsState() {
      this.getLocalCurrency();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Equipment-Report-Main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  .content-container {
    display: flex;
    width: 100%;
    gap: 4px;
  }

  .left-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
    resize: horizontal;
    overflow: auto;
    width: 260px;
    min-width: 170px;
    max-width: 30%;
  }

  .filter-container {
    border-radius: 4px;
    padding: 8px;
    padding-top: 4px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;
    min-height: 0;
  }

  .active-filter-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
    overflow: auto;
  }

  .table-container {
    min-height: 0;
    flex-grow: 1;
    padding: 8px;
    padding-top: 0px;
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }

  .filters-main {
    flex-shrink: 0;
  }
}
</style>
